import fetch from '@/utils/request'

const request = (rest = {}) => fetch({ ...rest, privateFlag: true })
export default {
  // 说明书列表
  getDrugBookList(data) {
    return request({
      url: `/emi/drugBook/list`,
      method: 'POST',
      data
    })
  },
  // 获取生产企业列表
  getProductCompanyList(data) {
    return request({
      url: `/emi/drugBook/productCompanyList`,
      method: 'POST',
      data
    })
  },
  // 新增/暂存电子说明书
  addDrugBook(data) {
    return request({
      url: `/emi/drugBook/add`,
      method: 'POST',
      data
    })
  },
  // 结构化字段获取: 不考虑分页
  getsStructureConfigList(data) {
    return request({
      url: `/emi/structure/queryStructureConfig`,
      method: 'POST',
      data
    })
  },
  // 根据电子说明书编码获取说明书(业务字段取新配置的)
  forUpdateDetail(data) {
    return request({
      url: `/emi/drugBook/forUpdateDetail`,
      method: 'POST',
      data
    })
  },
  // 根据电子说明书编码获取说明书(业务字段取新配置的)
  getQrCode(data) {
    return request({
      url: `/emi/drugBook/getQrCode`,
      method: 'POST',
      data
    })
  },
  // 生成二维码：由待投产状态变成投产状态
  generateOnlineQrCode(data) {
    return request({
      url: `/emi/drugBook/generateOnlineQrCode`,
      method: 'POST',
      data
    })
  },
  // 根据电子说明书编码获取说明书(业务字段取新配置的)
  backDetail(data) {
    return request({
      url: `/emi/drugBook/backDetail`,
      method: 'POST',
      data
    })
  },
  // 结构化字段获取: 不考虑分页
  getStructureConfigList(data) {
    return request({
      url: `/emi/structure/configList`,
      method: 'POST',
      data
    })
  },
  // 删除电子说明书(仅草稿状态的可以操作)
  drugBookDelete(data) {
    return request({
      url: `/emi/drugBook/delete`,
      method: 'POST',
      data
    })
  },
  // 说明书快照详情
  getSnapshotDetail(data) {
    return request({
      url: `/emi/drugBook/snapshotDetail`,
      method: 'POST',
      data
    })
  },
  // 根据药品规格获取关联的说明书
  getPackingRelatedNum(data) {
    return request({
      url: `/emi/drugBook/packingRelatedNum`,
      method: 'POST',
      data
    })
  },
  // 内容对比校验
  exportCompare(data) {
    return request({
      url: `/emi/drugBook/exportCompare`,
      method: 'POST',
      data
    })
  },
  // 根据快照获取审批流程日志
  snapshotLogList(data) {
    return request({
      url: `/emi/approve/snapshotLogList`,
      method: 'POST',
      data
    })
  },
  // 云端实时保存
  realTimeSave(data) {
    return request({
      url: `/emi/drugBook/realTimeSave`,
      method: 'POST',
      data,
      hideLoading: true
    })
  },
  // 预览
  drugBookPreView(data) {
    return request({
      url: `/emi/drugBook/preView`,
      method: 'POST',
      data
    })
  },
  // 保存语音校正记录
  fetchSaveVoiceCorrectionRecord(data = {}) {
    return request({
      url: `/emi/drugBook/saveVoiceCorrectionRecord`,
      method: 'POST',
      data
    })
  },
  // 获取语音校正记录
  fetchGetVoiceCorrectionRecord(data = {}) {
    return request({
      url: `/emi/drugBook/getVoiceCorrectionRecord`,
      method: 'POST',
      data,
      hideLoading: true
    })
  }
}
